import { __decorate, __metadata } from "tslib";
import { IsUUID } from 'class-validator';
export class CourtSystem {
    /**
     * @param id Uniquely identifies the court system
     * @param name The name of the court system
     * @param code A short code (ideally two characters long) to identify the court system by.
     * @param region A region where the court system's content is stored
     * @param isPublished Whether a court system has been published to all For The Record users
     * @param productionStatus The internal production status of the court system
     * @param licensingTier The licensing tier assigned to the court system
     */
    constructor(id, name, code, region, isPublished, productionStatus, licensingTier) {
        this.name = name;
        this.code = code;
        this.region = region;
        this.isPublished = isPublished;
        this.productionStatus = productionStatus;
        this.licensingTier = licensingTier;
        this.id = id;
    }
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CourtSystem.prototype, "id", void 0);
